<template>
  <div class="product-price-block-mobile">
    <div class="product-price-block-mobile__price _current">
      {{ discountedOnCountFormatted }}
    </div>
    <div v-if="isGift" class="product-price-block-mobile__gift">
      Подарок
    </div>
    <div v-else-if="isSale" class="product-price-block-mobile__price _old">
      {{ totalOnCountFormatted }}
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import { priceFormatted } from '@/utils/formatters/formattedPrice';

export default defineComponent({
  name: 'PricesBlock',
  props: {
    amount: { type: Object, default: () => ({ discounted: 0, total: 0 }) },
    quantityInBasket: { type: Number, default: 1 },
    isGift: { type: Boolean, default: false },
  },
  setup(props) {
    const totalOnCountFormatted = computed(() => {
      const price = props.amount.total * props.quantityInBasket;
      return priceFormatted(price, { setFreeText: false });
    });

    const discountedOnCountFormatted = computed(() => {
      const price = props.amount.discounted * props.quantityInBasket;
      return priceFormatted(price, { setFreeText: false });
    });

    const isSale = computed(() => +props.amount.discounted < +props.amount.total);

    return {
      totalOnCountFormatted,
      discountedOnCountFormatted,
      isSale,
    };
  },
});
</script>

<style lang="less">
.product-price-block-mobile {
  display: flex;
  align-items: center;

  &__price {
    &:not(:first-child) {
      margin-left: @size-x2;
    }

    &._current {
      .h3-mobile();

      color: @black;
    }

    &._old {
      .small();

      color: @gray-dark;
      text-decoration-line: line-through;
    }
  }

  &__gift {
    .small2();

    font-weight: 600;
    color: @white;
    background-color: @pink;
    border-radius: @main-size;
    margin-left: @size-x2;
    padding: 0 @main-size;
  }
}
</style>
